import { render, staticRenderFns } from "./PrestazioneSelection.vue?vue&type=template&id=5aac2fea&"
import script from "./PrestazioneSelection.vue?vue&type=script&lang=js&"
export * from "./PrestazioneSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports